import PdfDocumentPreview from '../ui/PdfDocumentPreview';
import { categoryLabels } from '../../utils/clientDocumentIntake';
import idIcon from '../../images/id-card-blue-doc.svg';
import addressIcon from '../../images/utility-blue-doc.svg';
import companyIcon from '../../images/corporate-doc-blue-2.svg';
import CvDocumentIcon from './CvDocumentIcon';

const icons = { id_document: idIcon, proof_of_address: addressIcon, trade_licence: companyIcon };

export default function ClientIntakeDocuments({ documents, showTitle = true, onPreview, onRemove, removalDisabled = false }) {
  const onlyCvs = documents.length > 0 && documents.every(document => document.category === 'cv');
  return <section className={`clientAttachedDocuments${showTitle ? ' clientAttachedDocuments--section' : ''}`} aria-label="Attached documents">
    {showTitle && <h3>Attached documents</h3>}
    <p className="clientAttachedDocumentsNote">{onlyCvs
      ? `${documents.length === 1 ? 'This CV' : 'These CVs'} will be saved under Other documents${showTitle ? '.' : ' (no client details will be changed) :'}`
      : `These documents will be saved with the client${showTitle ? '.' : ' (no client details will be changed) :'}`}</p>
    <ul>
      {documents.map((document, index) => {
        const file = document.file;
        const type = categoryLabels[document.category] || 'Document';
        const src = file?.dataBase64 ? `data:${file.contentType};base64,${file.dataBase64}` : '';
        return <li key={document.id}>
          <span className="clientAttachedDocumentNumber" aria-label={`Document ${index + 1}`}>{index + 1}</span>
          <button type="button" className="clientAttachedDocumentThumbnail" aria-label={`Preview ${type}`} title={`Preview ${type}`}
            disabled={!src} onClick={() => onPreview?.(document)}>
            {src && file.contentType === 'application/pdf'
              ? <PdfDocumentPreview file={src} maxPages={1} renderTextLayer={false} />
              : src && file.contentType?.startsWith('image/')
                ? <img src={src} alt="" />
                : <i className="bi bi-file-earmark" aria-hidden="true" />}
          </button>
          <div className="clientAttachedDocumentType">
            {document.category === 'cv' && <CvDocumentIcon />}
            {icons[document.category] && <img src={icons[document.category]} alt="" aria-hidden="true" />}
            <span>{document.category === 'cv' ? 'Curriculum Vitae' : type}</span>
            {document.category === 'cv' && !onlyCvs && <small style={{ color: '#708492', fontSize: 12 }}>Other documents</small>}
          </div>
          <button type="button" className="clientAttachedDocumentRemove" aria-label={`Remove ${type}`} title={`Remove ${type}`}
            disabled={removalDisabled} onClick={() => onRemove?.(document.id)}>
            <i className="bi bi-trash" aria-hidden="true" />
          </button>
        </li>;
      })}
    </ul>
  </section>;
}
